import { getLoanDetails, formatCurrency, calculateAge, getLoanEligibility } from '../utils/loanCalculations';
import { FaCheckCircle, FaUser, FaBriefcase, FaBuilding } from 'react-icons/fa';
import './LoanCalculation.css';

const CustomerProfile = ({ formData, handleChange, handleSubmit, prevStep, errors }) => {
  // Calculate customer age
  const customerAge = formData.dob ? calculateAge(formData.dob) : null;
  
  // Check loan eligibility
  const eligibility = formData.customerType && customerAge 
    ? getLoanEligibility(formData.customerType, customerAge)
    : null;
  
  // Calculate loan details when we have the necessary data
  const loanDetails = formData.loanType && formData.customerType && formData.dob
    ? getLoanDetails(
        formData.loanType, 
        formData.customerType, 
        parseFloat(formData.loanAmount) || 0, 
        customerAge, 
        formData.dob,
        formData.netProfit,
        formData.otherIncome,
        formData.existingEMI,
        formData.monthlySalary
      )
    : null;




  const renderSalariedFields = () => (
    <>
      {/* <div className={errors.netMonthlySalary ? 'error' : ''}>
        <label>Net Monthly Salary (₹):</label>
        <input
          type="number"
          name="netMonthlySalary"
          value={formData.netMonthlySalary}
          onChange={handleChange}
          required
          min="0"
        />
        {errors.netMonthlySalary && <div className="error-message">{errors.netMonthlySalary}</div>}
      </div>
      <div className={errors.monthlyEMI ? 'error' : ''}>
        <label>Monthly EMI (₹):</label>
        <input
          type="number"
          name="monthlyEMI"
          value={formData.monthlyEMI}
          onChange={handleChange}
          required
          min="0"
        />
        {errors.monthlyEMI && <div className="error-message">{errors.monthlyEMI}</div>}
      </div> */}
    </>
  );

  const renderBusinessFields = () => (
    <>
      <div className={errors.businessType ? 'error' : ''}>
        <label>Business Type:</label>
        <select 
          name="businessType" 
          value={formData.businessType} 
          onChange={handleChange} 
          required
        >
          <option value="">Select Business Type</option>
          <option value="Service">Service</option>
          <option value="Manufacturing">Manufacturing</option>
          <option value="Trading">Trading</option>
        </select>
        {errors.businessType && <div className="error-message">{errors.businessType}</div>}
      </div>

      {formData.businessType && (
        <>
          <div className={errors.annualTurnover ? 'error' : ''}>
            <label>Last Year Annual Turnover (₹):</label>
            <input
              type="number"
              name="annualTurnover"
              value={formData.annualTurnover}
              onChange={handleChange}
              required
              min="0"
            />
            {errors.annualTurnover && <div className="error-message">{errors.annualTurnover}</div>}
          </div>
        </>
      )}

      {/* <div className={errors.monthlyEMI ? 'error' : ''}>
        <label>Monthly EMI (₹):</label>
        <input
          type="number"
          name="monthlyEMI"
          value={formData.monthlyEMI}
          onChange={handleChange}
          required
          min="0"
        />
        {errors.monthlyEMI && <div className="error-message">{errors.monthlyEMI}</div>}
      </div> */}
    </>
  );

  return (
    <div className="form-container">
      <h2>Customer Profile</h2>
      
      {/* Eligibility Status */}
      {eligibility && (
        <div className={`eligibility-status ${eligibility.eligible ? 'eligible' : 'not-eligible'}`}>
          <h3>Loan Eligibility Status</h3>
          {/* <p className={eligibility.eligible ? 'success' : 'error'}>
            {eligibility.eligible ? '✓ Eligible' : '✗ Not Eligible'}
          </p>
          <p>{eligibility.reason}</p> */}
          {eligibility.eligible && (
            <p><strong>Your Age:</strong> {customerAge} years</p>
          )}
        </div>
      )}

      {/* Approved Loan Amount - Prominent Card */}
      {loanDetails && (
        <div className={`approved-amount-card ${loanDetails.isEligible ? '' : 'error'}`}>
          <h2><FaCheckCircle style={{ marginRight: '10px', color: loanDetails.isEligible ? '#4caf50' : '#f44336' }} /> Loan Eligibility</h2>
          <div className="amount-display">
            <div className="amount-value">{formatCurrency(loanDetails.approvedAmount)}</div>
            <div className="amount-label">Eligible Loan Amount (Based on EMI Capacity)</div>
          </div>
          {!loanDetails.isEligible && (
            <p style={{ color: '#f44336', marginTop: '1rem' }}>Not eligible for loan at this time.</p>
          )}
        </div>
      )}

      {/* Loan Calculation Display */}
      {loanDetails && (
        <div className={`loan-calculation-display ${loanDetails.isEligible ? '' : 'error'}`}>
          <h3>Loan Calculation Details</h3>
          <div className="calculation-grid">
            <div className="calculation-item">
              <span className="label">Monthly EMI Capacity:</span>
              <span className="value highlight">{formatCurrency(loanDetails.emiCapacity)}</span>
            </div>
            <div className="calculation-item">
              <span className="label">Eligible Loan Amount:</span>
              <span className="value highlight">{formatCurrency(loanDetails.approvedAmount)}</span>
            </div>
            <div className="calculation-item">
              <span className="label">Interest Rate (Fixed):</span>
              <span className="value">{loanDetails.interestRate}% p.a.</span>
            </div>
            <div className="calculation-item">
              <span className="label">Loan Tenure:</span>
              <span className="value">{loanDetails.tenureYears} years ({loanDetails.tenure} months)</span>
            </div>
            <div className="calculation-item">
              <span className="label">Monthly EMI:</span>
              <span className="value highlight">{formatCurrency(loanDetails.emi)}</span>
            </div>
            <div className="calculation-item">
              <span className="label">Total Interest:</span>
              <span className="value">{formatCurrency(loanDetails.totalInterest)}</span>
            </div>
            <div className="calculation-item">
              <span className="label">Total Payment:</span>
              <span className="value">{formatCurrency(loanDetails.totalPayment)}</span>
            </div>
          </div>
          {loanDetails.isEligible && (
            <div className="info-box">
              <strong>How This Works:</strong>
              <ul style={{ marginLeft: '1.5rem', marginTop: '0.5rem' }}>
                <li>Your EMI capacity is calculated based on your income and existing obligations</li>
                <li>Eligible loan amount is determined by what EMI capacity can support</li>
                <li>Monthly EMI of {formatCurrency(loanDetails.emi)} fits within your ₹{formatCurrency(loanDetails.emiCapacity)} capacity</li>
              </ul>
              <br/>
              <strong>Note:</strong> Loan tenure is automatically calculated based on your age ({customerAge} years), 
              customer type ({formData.customerType}), and loan type ({formData.loanType}). 
              The system ensures you can comfortably repay the loan before reaching the maximum age limit.
            </div>
          )}
          {!loanDetails.isEligible && (
            <div className="info-box error">
              <strong>Unfortunately:</strong> Based on your current income and financial obligations, 
              you may not be eligible for a loan at this time. Please contact our customer service for alternative options.
            </div>
          )}
        </div>
      )}


      
      <form onSubmit={handleSubmit}>
        <div className="info-box" style={{
          background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)',
          padding: '1rem',
          borderRadius: '10px',
          border: '2px solid #42a5f5',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: 0, color: '#1565c0', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
            <FaUser style={{ marginRight: '10px' }} /> Customer Type: <strong>{formData.customerType}</strong>
          </p>
          <p style={{ margin: '0.5rem 0 0 0', color: '#1565c0', fontSize: '0.9rem', display: 'flex', alignItems: 'center' }}>
            {formData.customerType === 'Salaried' 
              ? <><FaBriefcase style={{ marginRight: '10px' }} /> You are applying as a Salaried Individual</>
              : <><FaBuilding style={{ marginRight: '10px' }} /> You are applying as a Business Owner</>}
          </p>
        </div>

        {formData.customerType === 'Salaried' && renderSalariedFields()}
        {formData.customerType === 'Business Owner' && renderBusinessFields()}

        <div className="button-group">
          <button type="button" onClick={prevStep}>Back</button>
          <button 
            type="submit"
          >
            Submit Application
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerProfile;